var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconListNumbered24Line = function SvgIconListNumbered24Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 6.45H9.8v1.7h8.7v-1.7ZM18.5 11.15H9.8v1.7h8.7v-1.7ZM18.5 15.85H9.8v1.7h8.7v-1.7ZM5.75 11.175H7v.4H5.75v2.1h2.1v-.85H6.6v-.4h1.25v-2.1h-2.1v.85ZM5.75 15.875H7v.4H5.75v.85H7v.4H5.75v.85h2.1v-3.35h-2.1v.85ZM6.375 8.975h.85v-3.35h-.85v.4H5.8v.85h.575v2.1Z",
    fill: "current"
  })));
};
export default SvgIconListNumbered24Line;